<clr-modal #modal [(clrModalOpen)]="showSelectNodeModal" [clrModalSize]="'md'">
  <h3 class="modal-title">Select node</h3>
  <div class="modal-body">
    <app-configuration-select-node [rootId]="selectNodeProperty.selectNodeRootNodeId"
    [rootLabel]="selectNodeProperty.selectNodeRootNodeLabel" [referenceNodeTypeId]="selectNodeProperty.selectNodeNodeLabel"
    [rootIsCustomerSpecific]="selectNodeProperty.selectNodeRootIsCustomerSpecific" [customerId]="customerId"
    [getNodeDisplayName]="getNodeDisplayNameCallback" (onNodeSelect)="onSelectNode($event)" (onDblClick)="showSelectNodeModal = false">
  </app-configuration-select-node>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="showSelectNodeModal = false;">Cancel</button>
    <button type="button" class="btn btn-danger-outline" (click)="showSelectNodeModal = false; clearValue();">Clear</button>
    <button type="button" class="btn btn-primary" (click)="showSelectNodeModal = false">Select node</button>
  </div>
</clr-modal>

<clr-input-container *ngIf="!selectNodeProperty.hidden" (click)="showSelectNodeModal = true">
  <label class="clr-col-12">{{selectNodeProperty.header}}</label>
  <input clrInput class="btn btn-sm btn-secondary selectnode-button" type="button" value="{{selectedNodeName}}" (click)="showSelectNodeModal = true">
</clr-input-container>
<label class="clr-col-12 tooltip">{{selectNodeProperty.tooltip}}</label>
